export default __webpack_public_path__ + "static/media/foto6.ae76532b.jpg";